import React from 'react'
import { OverlayTrigger, Popover } from 'react-bootstrap'

const HoverWrapper = ({
  element,
  uniqueId,
  hoverText,
  title,
  placement = 'left',
  style = {},
}) => {
  const popoverHoverFocus = (
    <Popover id={uniqueId} title={title} style={style}>
      {hoverText}
    </Popover>
  )

  return (
    <OverlayTrigger
      trigger={['hover']}
      placement={placement}
      overlay={popoverHoverFocus}
    >
      {element}
    </OverlayTrigger>
  )
}

export default HoverWrapper
